import { render, staticRenderFns } from "./dialogTask.vue?vue&type=template&id=644bae1a&scoped=true&"
import script from "./dialogTask.vue?vue&type=script&lang=js&"
export * from "./dialogTask.vue?vue&type=script&lang=js&"
import style0 from "./dialogTask.vue?vue&type=style&index=0&id=644bae1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bae1a",
  null
  
)

export default component.exports